import { render } from "./Spinner.vue?vue&type=template&id=ce222184"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=ce222184&lang=css"
script.render = render

export default script